import { AutoScrollCarousel } from 'components/AutoScrollCarousel'
import { urlForImage } from 'lib/sanity.image'

import Link from 'next/link'
import { ResponsiveImage } from 'components/Global/ResponsiveImage'
import { DonationTag } from 'components/Global/DonationTag'

export const Carousel = ({ items }) => {
  return (
    <div className="py-20">
      <AutoScrollCarousel
        direction="right"
        gutter={20}
        className="aspect-[2/2.6] md:aspect-[16/8]"
      >
        {items.map((item) => {
          const url = urlForImage(item.image)
            .auto('format')
            .width(1000)
            .quality(90)
            .url()
          const href = `/collections/${
            item.collection?.store?.slug?.current ?? ''
          }`
          const { title, description, cause } = item.collection ?? {}

          return (
            <div
              key={item._key}
              data-carousel-item
              className="relative mr-12 inline-flex h-full w-[90%] select-none snap-start flex-col justify-end overflow-hidden rounded-12 p-20 md:absolute md:mr-20 md:w-[40%] md:rounded-24"
            >
              <div className="pointer-events-none absolute inset-0 h-full w-full">
                <ResponsiveImage
                  src={url}
                  alt={item.image.alt ?? title}
                  className="pointer-events-none"
                />
              </div>
              <Link
                scroll={false}
                href={href}
                className="ease relative z-[9] cursor-pointer self-start text-12 leading-100 text-darkGray shadow-md transition-all duration-300 hover:scale-[1.01] hover:shadow-sm"
              >
                <div className="inline-block rounded-12 bg-white p-10 pr-16">
                  <div className="inline-block rounded-full bg-[#DEDEDE] px-8 py-4 text-8 uppercase">
                    {item.category}
                  </div>
                  <div className="pt-10">{title}</div>
                  <div className="pt-4 text-midGray">{description}</div>
                  <DonationTag {...cause} className="mt-16" />
                </div>
              </Link>
            </div>
          )
        })}
      </AutoScrollCarousel>
    </div>
  )
}
